module.exports = __webpack_public_path__ + "static/media/blueberry_221157.ff4c959a.png";